module.exports = __webpack_public_path__ + "imgs/pinterest-white.ea7322c7618896c375becbcc3560c7a0.svg";